'use strict';

var App = require('app');
var Misc = require('utils/misc');
var OOP = require('utils/oop');
var Utils = require('models/utils');

var ReportContent = Utils.CreateStdModel({
    both: {
        getBaseURL: function (reportID) {
            return '/api/v1/devices/reports/' + this.reportID + '/content';
        },
    },
    model: {
        urlRoot: function () {
            return this.getBaseURL(this.reportID || this.get('report_id'));
        },
    },
    collection: {
        url: function () {
            return this.getBaseURL(this.reportID);
        },
    },
});

var ReportDeviceModel = OOP.extend(
    Backbone.Model,
    {
        urlRoot: function () {
            return '/api/v1/devices/reports';
        },
        initialize: function (options) {
            Backbone.Select.Me.applyTo(this);
        },
    },
    'ReportDeviceModel'
);

var ReportDeviceCollection = OOP.extend(
    Backbone.Collection,
    {
        model: ReportDeviceModel,
        url: function () {
            return '/api/v1/devices/reports';
        },
        initialize: function (initData, options) {
            this.base.initialize();
            Utils.SelectableCollection.applyTo(this);
        },
    },
    'ReportDeviceCollection'
);

var ReportDeviceList = OOP.extend(
    Backbone.Model,
    {
        url: function () {
            var filter = this.filter;
            return Misc.buildURL('/api/v1/devices/reports', {
                limit: filter.limit,
                offset: filter.offset,
                sortcol: filter.sortCol,
                sortdir: filter.sortDesc,
            });
        },
        initialize: function (initData, options) {
            this.base.initialize();
            Utils.SelectableCollection.applyTo(this);
        },
    },
    'ReportDeviceList'
);

var ReportDeviceFileModel = OOP.extend(
    Backbone.Model,
    {
        initialize: function (options) {
            Backbone.Select.Me.applyTo(this);
        },
    },
    'ReportDeviceFileModel'
);

var ReportDeviceFileCollection = OOP.extend(Backbone.Collection, {
    model: ReportDeviceFileModel,
    initialize: function (initData, options) {
        this.base.initialize();
        Utils.SelectableCollection.applyTo(this);
    },
});

var ReportDeviceFileList = OOP.extend(Backbone.Model, {
    url: function () {
        var filter = this.filter;
        return Misc.buildURL('/api/v1/devices/reports/' + filter.reportID + '/files', {
            limit: filter.limit,
            offset: filter.offset,
            sortcol: filter.sortCol,
            sortdesc: filter.sortDesc,
        });
    },
    initialize: function (initData, options) {
        this.base.initialize();
        Utils.SelectableCollection.applyTo(this);
    },
});

var API = {
    deviceReportModel: function (id) {
        return Misc.deferredFct(function (defer) {
            var item = new ReportDeviceModel({ id: id });
            item.fetch({
                success: function (data) {
                    defer.resolve(data);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    deviceReportDownloadList: function (filter) {
        return Misc.deferredFct(function (defer) {
            var list = new ReportDeviceFileList();
            list.filter = filter;
            list.fetch({
                success: function (data) {
                    data.set('collection', new ReportDeviceFileCollection(data.get('items')));
                    data.setPage = function (page, itemsPerPage, sortCol, sortDesc, onComplete) {
                        this.filter.offset = (page - 1) * itemsPerPage;
                        this.filter.limit = itemsPerPage;
                        this.filter.sortCol = sortCol;
                        this.filter.sortDesc = sortDesc;
                        onComplete(API.deviceReportDownloadList(this.filter));
                    };

                    defer.resolve(data);
                },
                error: function (err) {
                    defer.resolve(undefined);
                },
            });
        });
    },

    deviceReportList: function (filter) {
        return Misc.deferredFct(function (defer) {
            var list = new ReportDeviceList();
            list.filter = filter;
            list.fetch({
                success: function (data) {
                    data.set('collection', new ReportDeviceCollection(data.get('items')));
                    data.setPage = function (page, itemsPerPage, sortCol, sortDesc, onComplete) {
                        this.filter.offset = (page - 1) * itemsPerPage;
                        this.filter.limit = itemsPerPage;
                        this.filter.sortCol = sortCol;
                        this.filter.sortDesc = sortDesc;
                        onComplete(API.deviceReportList(this.filter));
                    };

                    defer.resolve(data);
                },
                error: function (err) {
                    defer.resolve(undefined);
                },
            });
        });
    },

    deviceReportContent: function (id) {
        return Misc.deferredFct(function (defer) {
            var list = new ReportContent.Collection();
            list.reportID = id;
            list.fetch({
                success: function (data) {
                    for (var i = 0; i < data.length; i++) {
                        data.models[i].set('is_first', i == 0);
                        data.models[i].set('is_last', i == data.length - 1);
                    }
                    defer.resolve(data);
                },
                error: function (err) {
                    defer.resolve(undefined);
                },
            });
        });
    },

    deviceReportPreviewPrepare: function (id) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                url: '/api/v1/devices/reports/' + id + '/preview_prepare',
                method: 'GET',
                success: function (data) {
                    defer.resolve(data);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    deviceReportContentMove: function (model, dir) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                url: '/api/v1/devices/reports/' + model.reportID + '/content/' + model.id,
                method: 'POST',
                data: JSON.stringify({ action: dir }),
                success: function () {
                    defer.resolve(true);
                },
                error: function () {
                    defer.resolve(false);
                },
            });
        });
    },

    deviceReportUpdate: function (list, fields) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'POST',
                url: '/api/v1/devices/reports/update',
                data: JSON.stringify({ list: list, fields: fields }),
                success: function (r) {
                    defer.resolve(true);
                },
                error: function (r) {
                    defer.resolve(false);
                },
            });
        });
    },
};

App.reqres.setHandler('report:devices:list', function (filter) {
    return API.deviceReportList(filter);
});

App.reqres.setHandler('report:devices:files', function (filter) {
    return API.deviceReportDownloadList(filter);
});

App.reqres.setHandler('report:devices:model', function (id) {
    return API.deviceReportModel(id);
});

App.reqres.setHandler('report:devices:content', function (id) {
    return API.deviceReportContent(id);
});

App.reqres.setHandler('report:devices:update', function (list, fields) {
    return API.deviceReportUpdate(list, fields);
});

App.reqres.setHandler('profile:reports:device:content:move', function (model, dir) {
    return API.deviceReportContentMove(model, dir);
});

App.reqres.setHandler('report:devices:preview:prepare', function (reportID) {
    return API.deviceReportPreviewPrepare(reportID);
});

module.exports = {
    Model: ReportDeviceModel,
    Collection: ReportDeviceCollection,
    ReportContent: ReportContent,
};
